import React from "react";

interface Props {
  expertResponseComment: string;
}
const ExpertResponseComment = ({ expertResponseComment }: Props) => {
  return (
    <div className="p-6 text-base bg-blue-50 border-0 border-l-4 border-solid border-blue-500 mt-4 rounded-none">
      <p
        className="m-0 p-0 text-base"
        dangerouslySetInnerHTML={{
          __html: expertResponseComment,
        }}
      />
      <p className="font-bold text-sm leading-4 m-0 mt-4">
        WebstaurantStore Customer Solutions
      </p>
    </div>
  );
};
export default ExpertResponseComment;
